module.exports = __webpack_public_path__ + "img/staked-new-parchment.2c4d7e2a.webp";